// Custom filters set to "Required in the value pack form" (Settings > Dynamic
// Filters). The Categories step registers them when it loads the filters, and
// the Categories step schema (schemas/valuePackSchema.js) checks them, so Next
// and Save stop until each one has a value. The backend checks them again.
let requiredFilters = [];

export const setRequiredFormFilters = (filters) => {
  requiredFilters = Array.isArray(filters) ? filters : [];
};

// Required filters with no value picked in `filterValues`
export const getMissingRequiredFilters = (filterValues) => {
  const values = filterValues && typeof filterValues === 'object' ? filterValues : {};
  return requiredFilters.filter((filter) => !(values[filter.key] || []).length);
};
